module.exports = __webpack_public_path__ + "static/media/ca-previous-arrow-icon.6fa8d2f4.svg";